import { render, staticRenderFns } from "./view_so.vue?vue&type=template&id=3773298e&scoped=true"
import script from "./view_so.vue?vue&type=script&lang=js"
export * from "./view_so.vue?vue&type=script&lang=js"
import style0 from "./view_so.vue?vue&type=style&index=0&id=3773298e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3773298e",
  null
  
)

export default component.exports